export const CalendarService = {
    // Crear un evento en Google Calendar con opción a Google Meet
    async createEvent(eventData, accessToken, createMeet = false) {
        try {
            const url = new URL('https://www.googleapis.com/calendar/v3/calendars/primary/events');
            if (createMeet) {
                url.searchParams.append('conferenceDataVersion', '1');
            }

            const body = {
                summary: eventData.title,
                description: eventData.description,
                start: {
                    dateTime: eventData.start, // ISO string
                    timeZone: 'America/Costa_Rica'
                },
                end: {
                    dateTime: eventData.end, // ISO string
                    timeZone: 'America/Costa_Rica'
                },
                location: eventData.location || '',
                reminders: {
                    useDefault: false,
                    overrides: [
                        { method: 'popup', minutes: 30 },
                        { method: 'email', minutes: 1440 }
                    ]
                }
            };

            if (createMeet) {
                body.conferenceData = {
                    createRequest: {
                        requestId: `meet-${Date.now()}`,
                        conferenceSolutionKey: { type: 'hangoutsMeet' }
                    }
                };
            }

            const response = await fetch(url.toString(), {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            const data = await response.json();
            if (!response.ok) throw new Error(data.error?.message || 'Error creando evento');
            return data;
        } catch (error) {
            console.error("Calendar Service Error:", error);
            throw error;
        }
    }
};
